<template>
  <div class="edt">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">{{ pageTitle }}
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <v-btn
          color="primary"
          class="mr-4"
          medium
          @click="onCancel"
          :disabled="form.$busy"
          text
          style="text-transform: none;"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save</v-btn>
      </div>
    </v-app-bar>
    <v-row class="px-4 py-4">
      <v-col
        lg="8"
        md="6"
        sm="12"
        xs="12"
      >
        <v-card
          outlined
          class="px-6 py-8"
        >

          <!-- <sport-selector
            v-model="form.sport_type"
            :disabled="loadingTags"
            :error-messages="replace(head(form.$getError('sport_type')), 'sport type', 'sport')"
          /> -->
          <sport-selector
            v-model="form.sport_type"
            :disabled="loadingTags"
            @change="tagTypeChanged"
            :error-messages="replace(head(form.$getError('sport_type')), 'tag type', 'sports')"
          />

          <league-selector
            :isNotMultiple="true"
            v-model="form.sport_league"
            :tagType="form.sport_type"
            @loadingState="state => this.loadingTags = state"
            @change="e => this.form.$clearError('sport_league')"
            :error-messages="replace(head(form.$getError('sport_league')), 'sport league', 'league')"
          />

          <v-text-field
            outlined
            flat
            label="Site Title"
            v-model="form.site_title"
            :error-messages="form.$getError('site_title')"
          />

          <v-text-field
            outlined
            flat
            label="Page Header"
            v-model="form.page_title"
            :error-messages="form.$getError('page_title')"
          />

          <v-textarea
            outlined
            name="input-7-4"
            label="Page Subheader"
            v-model="form.page_description"
            :error-messages="form.$getError('page_description')"
          />

          <image-file-input-viewer
            v-model="form.icon_thumbnail"
            :error-messages="form.$getError('icon_thumbnail')"
            label="Header Icon"
          />

          <v-text-field
            outlined
            flat
            label="Page H2"
            v-model="form.subheading_title"
            :error-messages="form.$getError('subheading_title')"
          />

          <v-textarea
            outlined
            name="input-7-4"
            label="Page H2 Copy"
            v-model="form.subheading_description"
            :error-messages="form.$getError('subheading_description')"
          />

          <div class="text-caption">Available Variables:
            <p class="font-weight-thin grey--text">
              ${sportName}, ${sportType}, ${matchDay}, ${matchMonth}, ${matchYear}, ${matchTime}, ${homeTeam}, ${visitingTeam}, ${venue}, ${matchDate}
            </p>
          </div>

          <v-text-field
            outlined
            flat
            label="Match Page H2"
            v-model="form.match_subheading_title"
            :error-messages="form.$getError('match_subheading_title')"
            hint="variables will be automaticall replaced by the actual values when rendered"
          />

          <v-textarea
            outlined
            name="input-7-4"
            label="Match Page H2 Copy"
            v-model="form.match_subheading_description"
            :error-messages="form.$getError('match_subheading_description')"
            hint="variables will be automaticall replaced by the actual values when rendered"
          />

          <!-- <content-editor
            v-if="showEditor"
            v-model="form.app_content"
            :error-messages="form.$getError('app_content')"
          /> -->
        </v-card>
      </v-col>
      <v-col
        lg="4"
        md="6"
        sm="12"
      >
        <social-sharing-meta-tag
          v-bind:title.sync="form.seo_scheduled_title"
          v-bind:description.sync="form.seo_scheduled_description"
          v-bind:image.sync="form.schedule_thumbnail"
          page_title="Scheduled SEO Meta Tags"
          hint_msg="${homeTeam} and ${visitingTeam} will be automaticall replaced by the actual team names based on the match ID"
          class="mb-6"
        />

        <v-card
          outlined
          class="px-6 pt-6 pb-3"
        >
          <div class="d-flex flex-row justify-space-between align-center pb-3 ">
            <label class="subtitle-1 d-block grey--text">Match SEO Meta Tags</label>
          </div>

          <div class="pb-2">
            <h5>Title</h5>
            <p class="mt-2">Match seo titles are autogenerated.</p>
          </div>

          <v-textarea
            outlined
            name="input-7-4"
            label="Description"
            hint="${homeTeam} and ${visitingTeam} will be automaticall replaced by the actual team names based on the match ID"
            v-model="form.seo_description"
          />

          <image-file-input-viewer
            v-model="form.match_thumbnail"
            :error-messages="form.$getError('icon_thumbnail')"
            label="Header Icon"
          />

        </v-card>
      </v-col>
    </v-row>
    <v-overlay
      absolute
      :value="updating"
    >
      <v-dialog
        v-model="updating"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>

<script>
import Form from '@/utils/form'
import get from 'lodash/get'
import head from 'lodash/head'
import replace from 'lodash/replace'
import BethubSeo from '@/models/BethubSeo'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import SocialSharingMetaTag from '@/components/SocialSharingMetaTag'
import SportSelector from '@/views/Home/Articles/shared/SportSelector'
import LeagueSelector from '@/views/Home/Articles/shared/LeagueSelector'
import { mapActions } from 'vuex'

const initialData = {
  app_title: null,
  app_description: null,
  app_page: null,
  app_content: null,
  sport_type: null,
  sport_league: null,
  seo_title: null,
  seo_description: null,
  seo_scheduled_title: null,
  seo_scheduled_description: null,
  site_title: null,
  page_title: null,
  page_description: null,
  schedule_thumbnail: null,
  match_thumbnail: null,
  icon_thumbnail: null,
  subheading_title: null,
  subheading_description: null,
  match_subheading_title: null,
  match_subheading_description: null
}

export default {
  data () {
    return {
      loading: false,
      updating: false,
      loading_message: 'Loading',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      loadingTags: false,
      form: new Form({
        ...initialData
      })
    }
  },
  props: {
    bethubSeo: {
      type: [BethubSeo, Object],
      default () {
        return {}
      }
    },
    pageTitle: {
      type: String,
      default: 'BetHub SEO template'
    },
    redirectCancelTo: {
      type: [String, Object],
      default () {
        return {
          name: 'bethub-seo-templates'
        }
      }
    },
    redirectSaveTo: {
      type: [String, Object],
      default () {
        return {
          name: 'bethub-seo-templates'
        }
      }
    }
  },

  components: {
    AppBarNavIcon,
    ImageFileInputViewer,
    SportSelector,
    LeagueSelector,
    SocialSharingMetaTag
  },

  methods: {
    head,
    replace,
    ...mapActions({
      updateRecord: 'betHubSeo/update'
    }),

    onCancel () {
      this.$router.replace(this.redirectCancelTo)
    },

    async onSave () {
      try {
        this.form.$busy = true
        this.form.$clearErrors()
        const data = this.form.$data()

        // if (this.isModeUpdate) {
        //   let formData = new FormData()
        //   formData.append('id', data.id)
        //   formData.append('_method', 'put')
        //   formData.append('sport_type', data.sport_type)
        //   formData.append('seo_description', data.seo_description)
        //   formData.append('seo_scheduled_description', data.seo_scheduled_description)
        //   formData.append('sport_league', data.sport_league)
        //   formData.append('page_title', data.page_title)
        //   formData.append('page_description', data.page_description)

        //   if (data.schedule_thumbnail && !data.schedule_thumbnail.id) { formData.append('schedule_thumbnail', data.schedule_thumbnail) }
        //   if (data.match_thumbnail && !data.match_thumbnail.id) { formData.append('match_thumbnail', data.match_thumbnail) }
        //   if (data.icon_thumbnail && !data.icon_thumbnail.id) { formData.append('icon_thumbnail', data.icon_thumbnail) }

        //   await this.updateRecord(formData)
        // } else {
        //   const bethubSeo = new BethubSeo(data)
        //   await bethubSeo.save()
        // }
        if (this.isModeUpdate) {
          data._method = 'put'

          if (data.schedule_thumbnail && data.schedule_thumbnail.id) { this.$delete(data, 'schedule_thumbnail') }
          if (data.match_thumbnail && data.match_thumbnail.id) { this.$delete(data, 'match_thumbnail') }
          if (data.icon_thumbnail && data.icon_thumbnail.id) { this.$delete(data, 'icon_thumbnail') }
        }

        const bethubSeo = new BethubSeo(data)
        await bethubSeo.save()

        this.$router.replace(this.redirectSaveTo)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    tagTypeChanged () {
      this.$set(this.form, 'sport_league', null)
      this.form.$clearError('sport_type')
      this.form.$clearError('sport_league')
    }

  },

  watch: {
    bethubSeo: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            ...initialData,
            ...val
          })
        }
      }
    }
  },

  computed: {
    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    }
  }
}
</script>
